import { useContext } from "react";
import { useParams } from "react-router-dom";
import {
  fetchWaiverRequestDoc,
  patchSaveApplication,
} from "../../../../services/network";
import { ParamType } from "../LoansPagev2";
import { getCookie } from "../../../../utils/Common";
import { LoansContext } from "../../../../context/LoansContext";
import { useFilePreview } from "../../../../hooks/useFilePreview";

export function useDocumentActions({
  dynamicConfig,
  documentList,
  setDocumentList,
  getChecklistPayload,
}: any) {
  const { loanId } = useParams<ParamType>();
  const { setLoanDetails } = useContext(LoansContext);
  const preview = useFilePreview();

  async function viewFile(doc: any) {
    const urlData = await fetchWaiverRequestDoc(dynamicConfig?.fileDownloadUrl, {
      path: doc?.documentPath,
    });
    preview.openPreview(urlData.data, doc.documentName);
  }

  async function handleDownloadDocument(doc: any) {
    try {
      const urlData = await fetchWaiverRequestDoc(
        dynamicConfig?.fileDownloadUrl,
        { path: doc?.documentPath },
      );
      window.open(urlData.data, "_blank");
    } catch (error) {
      console.error("Error downloading document:", error);
    }
  }

  async function handleDeleteDocument(doc: any) {
    try {
      // Soft delete: mark the document as deleted without removing it
      const updatedDocuments = documentList.map((d: any) =>
        d.id === doc.id ||
        (d.documentName === doc.documentName &&
          d.documentPath === doc.documentPath)
          ? {
              ...d,
              isDeleted: true,
              deletedOn: new Date(),
              deletedBy: getCookie("partyId") ?? "unknown",
            }
          : d,
      );
      const checklistPayload = getChecklistPayload?.(updatedDocuments) ?? {};
      await patchSaveApplication(loanId, {
        documents: updatedDocuments,
        ...checklistPayload,
      });
      setLoanDetails((prevData: any) => ({
        ...prevData,
        documents: updatedDocuments,
        ...checklistPayload,
      }));
      setDocumentList(updatedDocuments);
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  }

  return { preview, viewFile, handleDownloadDocument, handleDeleteDocument };
}
